<app-header></app-header>

<main class="success-container">
  <div class="success-content">
    <div class="success-icon">
      <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <h1 class="success-title">Paiement réussi !</h1>
    
    <!-- Section d'upload avec barre de progression -->
    <div class="upload-section" *ngIf="isUploading">
      <div class="upload-message">
        <p>{{ uploadMessage }}</p>
      </div>
      
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" [style.width.%]="uploadProgress"></div>
        </div>
        <span class="progress-text">{{ Math.round(uploadProgress) }}%</span>
      </div>
    </div>

    <!-- Section de conversion avec barre de progression -->
    <div class="conversion-section" *ngIf="isConverting">
      <div class="conversion-message">
        <p>{{ conversionMessage }}</p>
      </div>
      
      <div class="progress-container">
        <div class="progress-bar conversion-progress">
          <div class="progress-fill conversion-fill" [style.width.%]="conversionProgress"></div>
        </div>
        <span class="progress-text">{{ Math.round(conversionProgress) }}%</span>
      </div>
    </div>
    
    <div class="success-details">
      <p class="success-message">
        Votre paiement de <strong>{{ amount }}€</strong> a été traité avec succès.
      </p>
      
      <div class="file-info" *ngIf="filename">
        <h3>Fichier converti :</h3>
        <p class="filename">{{ filename }}</p>
      </div>

      <div class="email-info" *ngIf="email">
        <h3>Email de contact :</h3>
        <p class="email">{{ email }}</p>
      </div>
    </div>

    <div class="success-actions">
      <a *ngIf="downloadUrl && !isConverting && filename && !isUploading" [href]="downloadUrl" target="_blank" class="btn btn-primary">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M7 10L12 15M12 15L17 10M12 15V3" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Télécharger le fichier converti
      </a>

      <button class="btn btn-secondary" (click)="onNewConversion()" [disabled]="isUploading">
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 5V19M5 12H19" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        Nouvelle conversion
      </button>
    </div>

    <div class="success-note">
      <p>
        <strong>Note :</strong> Un email de confirmation a été envoyé à votre adresse email.
        Le fichier converti sera disponible dans les prochaines minutes.
      </p>
    </div>
  </div>
</main>

<app-footer></app-footer> 